import { RouteType } from "types/RouteType";
import departmentsRoute from "./Departments/departments.Route";
import permissionsRoute from "./Permissions/permissions.Route";
import rolesRoute from "./Roles/roles.Route";
import userManagementRoute from "./UserManagement/userManagement.Route";
import clientAccessRoute from "./ClientAccess/clientAccess.Route";
import gitIdentitiesRoute from "./GitIdentities/gitIdentities.Route";
import peopleRoute from "./People/people.Route";

// NOTE: the old CRM HomeDashboard (./Dashboard) was removed with the
// command-center overhaul — the '/home' path is now owned by the
// views/home CommandCenter route ('Home').
// NOTE: the Standard Procedures route was removed — it was an empty
// placeholder body subscribed to a `standard-procedures/file` channel that no
// API service ever served, and it was reachable ungated by every viewer.
const administrationRoutesList: RouteType[] = [
  departmentsRoute,
  ...permissionsRoute,
  rolesRoute,
  ...userManagementRoute,
  clientAccessRoute,
  gitIdentitiesRoute,
  // Delegated user administration: administrators and the people
  // administrators they appoint (gated by PeopleAccessStore, not requiresAdmin).
  peopleRoute,
];

export default administrationRoutesList;
